import { EmptyComponent } from "../common/EmptyComponent.js";
import Loadable from "react-loadable";

export const LeftAreaPC = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "menu/pc/left-area" */
      "./LeftAreaPC.js"
    ),
  loading: EmptyComponent
});

export const MenuChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "menu/pc/menu" */
      "../Menu/Menu.js"
    ),
  loading: EmptyComponent
});
